import BrandLogo from "@/components/BrandLogo";
import type { DoorOrg } from "@/hooks/useOrgDoor";
import { cn } from "@/lib/utils";

/**
 * Brand lockup for the auth doors: the BusinessLocating mark, and — on an
 * organization's door — that organization's logo beside it, matching the nav
 * on the org's landing page.
 *
 * The org logo keeps its own brand colours (it sits on its own light chip),
 * because a partner's mark is never recoloured to fit our palette.
 */
export default function DoorBrandLockup({
  org,
  className,
  orgClassName,
}: {
  org: DoorOrg | null;
  /** Sizing for the BusinessLocating logo. */
  className?: string;
  /** Sizing for the organization logo. */
  orgClassName?: string;
}) {
  return (
    <div className="flex items-center gap-3">
      <BrandLogo variant="dark" className={cn("w-auto object-contain", className)} />
      {org?.logo_url && (
        <>
          <span className="h-8 w-px shrink-0 bg-border/70" aria-hidden="true" />
          <img
            src={org.logo_url}
            alt={org.name}
            className={cn("w-auto shrink-0 object-contain", orgClassName ?? className)}
          />
        </>
      )}
    </div>
  );
}
